import { render, staticRenderFns } from "./AircraftTile.vue?vue&type=template&id=1fc0f99c&scoped=true"
import script from "./AircraftTile.vue?vue&type=script&lang=ts"
export * from "./AircraftTile.vue?vue&type=script&lang=ts"
import style0 from "./AircraftTile.vue?vue&type=style&index=0&id=1fc0f99c&prod&module=true&scoped=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1fc0f99c",
  null
  
)

export default component.exports